import { render, staticRenderFns } from "./AssignGuestInformationPage.vue?vue&type=template&id=70a18807"
import script from "./AssignGuestInformationPage.vue?vue&type=script&lang=js"
export * from "./AssignGuestInformationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports